import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { Customer } from '../transcation';
import { CustomerService } from '../transcation.service';

@Component({
  selector: 'app-create-transcation',
  templateUrl: './create-transcation.component.html',
  styleUrls: ['./create-transcation.component.css']
})
export class CreateTranscationComponent implements OnInit {
transcationType: string[];
  customer: Customer = new Customer();
  submitted = false;

  constructor(private customerService: CustomerService) { }

  ngOnInit() {
    this.transcationType = ['CREDIT', 'DEBIT'];
  }

  newCustomer(): void {
    this.submitted = false;
    this.customer = new Customer();
  }

  save() {
    this.customerService.createCustomer(this.customer);
    this.customer = new Customer();
  }

  onSubmit() {
    this.submitted = true;
    this.save();
  }
}
